import { Dispatch as ReactDispatch } from "react";
import { ZoneDimensions } from "../../../types";
import { ChangeCurrentCellTypeAction } from "./changeCurrentCellType";
import { MoveToNextCellAction } from "./moveToNextCell";
import { NumberPressedAction } from "./numberPressed";

import { AddColumnAction } from "./reducers/addColumn";
import { AddRowAction } from "./reducers/addRow";
import { ClearCellsAction } from "./reducers/clearCells";
import { ClearMouseDragPositionAction } from "./reducers/clearMouseDragPosition";
import { ClearMousePositionAction } from "./reducers/clearMousePosition";
import { DeleteSelectedSegmentsAction } from "./reducers/deleteSelectedSegments";
import { HideTableUIAction } from "./reducers/hideTableUI";
import { MergeCellsAction } from "./reducers/mergeCells";
import { RedoAction } from "./reducers/redo";
import { ResetAction } from "./reducers/reset";
import { SetMouseDragPositionAction } from "./reducers/setMouseDragPosition";
import { SetMousePositionAction } from "./reducers/setMousePosition";
import { SetWithinGutterAction } from "./reducers/setWithinGutter";
import { ShowTableUIAction } from "./reducers/showTableUI";
import { SplitCellAction } from "./reducers/splitCell";
import { UndoAction } from "./reducers/undo";
import { ToggleBorderExplicitnessAction } from "./toggleBorderExplicitness";

export type Edge = Readonly<{
  adjacentCells: {
    [zoneId: string]: true;
  };
  end: number;
  maxPosition: number;
  minPosition: number;
  orientation: "horizontal" | "vertical";
  position: number;
  start: number;
}>;

export type Cell = ZoneDimensions &
  {
    selectedBorder: "bottom" | "left" | "right" | "top" | null;
    selected: boolean;
  };

export type State = Readonly<{
  cellHistory: ReadonlyArray<ReadonlyArray<Cell>>;
  cellHistoryIndex: number;
  cells: ReadonlyArray<Cell>;
  dragOffset: {
    maxX: number;
    maxY: number;
    minX: number;
    minY: number;
    x: number;
    y: number;
  };
  // mouse drag start position is [x, y]
  mouseDragStart: [number, number] | null;
  // mouse position is [x, y]
  mousePosition: [number, number] | null;
  showTableUI: boolean;
  withinGutter: "horizontal" | "vertical" | null;
  zoneHeight: number;
  zoneWidth: number;
  selectedCellTypeGroup: "Basic" | "Summary" | null;
}>;

export type Action =
  | AddColumnAction
  | AddRowAction
  | ClearCellsAction
  | ClearMouseDragPositionAction
  | ClearMousePositionAction
  | DeleteSelectedSegmentsAction
  | HideTableUIAction
  | MergeCellsAction
  | RedoAction
  | ResetAction
  | SetMouseDragPositionAction
  | SetMousePositionAction
  | SetWithinGutterAction
  | ShowTableUIAction
  | SplitCellAction
  | UndoAction
  | ChangeCurrentCellTypeAction
  | ToggleBorderExplicitnessAction
  | NumberPressedAction
  | MoveToNextCellAction;

export type Dispatch = ReactDispatch<Action>;

export const CELL_THRESHOLD = 2;
export const CELL_BORDER_CLICK_BUFFER = 3;
